import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { FichaTecnica } from '../../types/fichas';
import { fichasTecnicasService } from '../../services';

const formatCurrency = (value?: number) =>
  typeof value === 'number'
    ? value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : '-';

const columns: ResourceColumn<FichaTecnica>[] = [
  { header: 'Cdigo', accessor: 'codigo' },
  { header: 'Ttulo', accessor: 'titulo' },
  {
    header: 'Produto final',
    render: (item) => item.produto_final_nome ?? item.produto_final_codigo ?? '-',
  },
  {
    header: 'Status',
    render: (item) => (
      <Badge bg={item.ativa ? 'success' : 'secondary'}>
        {item.ativa ? 'Ativa' : 'Inativa'}
      </Badge>
    ),
  },
  {
    header: 'Custo total',
    render: (item) => formatCurrency(item.custo_total),
  },
];

export const FichasListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Fichas técnicas"
      description="Controle das fichas de produto e seus custos."
      columns={columns}
      service={fichasTecnicasService}
      createPath="/admin/producao/fichas-tecnicas/novo"
      onEdit={(record) => record.id && navigate(`/admin/producao/fichas-tecnicas/${record.id}`)}
    />
  );
};
